// Core packages
import { Component, OnInit } from '@angular/core';

// Third party packages
import { MatDialog } from '@angular/material';
import { fromEvent, Observable, Subscription } from 'rxjs';

// Custom packages
import { AuthService } from 'src/app/modules/auth/auth.service';
import { ChangePasswordDialogComponent } from 'src/app/shared/components/dialogs/change-password-dialog/change-password-dialog.component';
import { IUser } from 'src/app/shared/models/user/user.interface';
import { ThemeService } from 'src/app/shared/services/theme.service';

@Component({
  selector: 'app-wrapper-app',
  templateUrl: './app-wrapper.component.html',
  styleUrls: ['./app-wrapper.component.scss']
})
export class AppWrapperComponent implements OnInit {
  private subscriptions: Subscription[] = [];
  isOnline = true;
  loggedUser: IUser;
  online$: Observable<any>;
  offline$: Observable<any>;
  roleChanging$: Observable<any>;
  isRoleChanging = false;

  /**
   * Class constructor
   */
  constructor(
    private authService: AuthService,
    public dialog: MatDialog,
    private themeService: ThemeService,
  ) { }

  /**
   * Init component
   *
   * @returns undefined
   */
  ngOnInit(): void {
    this.subscriptions.push(
      this.authService.loggedUser$.subscribe(
        (res: IUser) => {
          this.updateBodyClasses(res);
          this.loggedUser = res;
          if (
            this.loggedUser
            && this.loggedUser.originalPassword
            && !this.dialog.openDialogs.length
          ) {
            this.onChangePasswordDialogOpen();
          }
        }
      )
    );

    this.online$ = fromEvent(window, 'online');
    const onlineSubscription = this.online$.subscribe(
      res => {
        this.isOnline = true;
      }
    );
    this.subscriptions.push(onlineSubscription);

    this.offline$ = fromEvent(window, 'offline');
    const offlineSubscription = this.offline$.subscribe(
      res => {
        this.isOnline = false;
      }
    );
    this.subscriptions.push(offlineSubscription);

    this.roleChanging$ = this.authService.isRoleChanging$;
    this.subscriptions.push(this.roleChanging$.subscribe(
      res => {
        this.isRoleChanging = res;
      }
    ));
  }


  /**
   * Update body classes depenging on logged user roles
   * First of all remove al classes for previous role (if present)
   * and then set a class for each current role
   *
   * @since 1.0.0
   */
  updateBodyClasses(newUserData: IUser): void {
    if (this.loggedUser) {
      this.loggedUser.userRoles.forEach(obj => { // this.loggedUser.userRoles.forEach(role => {
        this.themeService.removeClassToBody(`logged-${encodeURI(obj.role.name.toLowerCase())}`);
      });
    }
    if (newUserData) {
      newUserData.userRoles.forEach(obj => { // newUserData.userRoles.forEach(role => {
        this.themeService.setClassToBody(`logged-${encodeURI(obj.role.name.toLowerCase())}`);
      });
    }
  }

  /**
   * Open change password dialog
   */
  onChangePasswordDialogOpen() {
    this.dialog.open(ChangePasswordDialogComponent, {
      data: {
        user: this.loggedUser,
      },
      width: '500px',
    });
  }
}
